(() => {
  if (window.VelvetContactInitialized) return;
  window.VelvetContactInitialized = true;

  const reveal = (root = document) => {
    const items = root.querySelectorAll(".velvet-contact-reveal:not([data-velvet-contact-ready])");

    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      items.forEach((item) => item.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    items.forEach((item) => {
      item.dataset.velvetContactReady = "true";
      observer.observe(item);
    });
  };

  const focusFormFromHash = () => {
    if (!["#contact", "#contact-form"].includes(window.location.hash)) return;
    const form = document.querySelector("[data-velvet-contact-form]");
    if (!form) return;
    window.requestAnimationFrame(() => {
      form.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        block: "start",
      });
    });
  };

  const focusStatus = (root = document) => {
    const status = root.querySelector(".velvet-contact-main__success, .velvet-contact-main__errors");
    if (!status || status.dataset.focused === "true") return;
    status.dataset.focused = "true";
    status.focus({ preventScroll: true });
  };

  const init = (root = document) => {
    reveal(root);
    focusStatus(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      init();
      focusFormFromHash();
    });
  } else {
    init();
    focusFormFromHash();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  window.addEventListener("hashchange", focusFormFromHash);
})();
